<script>
    export let duration;

    Number.prototype.toFixed02 = function (r) {
        var pad = "";
        var i = this.toFixed(0);
        while ((pad + i).length < 2)
            pad += "0";
        return pad + this.toFixed(r);
    };

    function hrDuration27(dur) {
        var days = "";
        var h = "00", m = "00", s = "00.0";
        var sign = "";
        var i;

        if (dur < 0) {
            sign = "-";
            dur = -dur;
        }

        dur = Math.ceil(dur / 27000);

        i = Math.floor(dur / 1000 / 3600 / 24);
        if (i >= 2) {
            days = i + " days, ";
            dur -= i * 1000 * 3600 * 24;
        }

        i = Math.floor(dur / 1000 / 3600);
        if (i >= 1) {
            h = i.toFixed02(0);
            dur -= i * 1000 * 3600;
        }

        i = Math.floor(dur / 1000 / 60);
        if (i >= 1) {
            m = i.toFixed02(0);
            dur -= i * 1000 * 60;
        }

        i = dur / 1000;
        s = i.toFixed02(2);

        return sign + days + h + ":" + m + ":" + s;
    }
</script>

<span class="duration">{hrDuration27(duration)}</span>

<style>
    .duration {
        font-family: "Courier", "Courier New";
    }
</style>